module.exports = __webpack_public_path__ + "static/media/home-blue-grid-1.c8da1ba5.svg";